import { usePermissions } from "hooks/usePermissions";
import React from "react";
import GenericButton from "./generic";

interface DropdownButtonProps {
  text: string;
  onClick: () => void;
  extra?: string;
  permissionRole?: string;
  sizes?: "lg" | "md" | "sm" | "xs";
  color?: "primary" | "secondary" | "tertiary" | "white" | string;
}

const DropdownButton: React.FC<DropdownButtonProps> = ({
  text,
  onClick,
  extra,
  permissionRole,
  sizes = 'sm',
  color,
}) => {
  const { canShow } = usePermissions();

  if (permissionRole && !canShow(permissionRole)) {
    return null;
  }
  return (
    <GenericButton text={text} onClick={onClick} size={sizes} variant="ghost" color={color} extra={extra}/>
  );
};

export default DropdownButton;
